import {ReactReduxModal} from '../../core-utilities/react-redux-modals';
import {ReactReduxModalHOC} from '../../core-utilities/react-redux-modals/components/ReactReduxModalHOC';
import {AuthModal, modalOptions} from '../components/AuthModal';
import {getAuthModal} from '../reducers/state';
import {AUTH_MODAL_PREFIX} from './state';
import {logger} from './logger';

const options = {
  prefix: AUTH_MODAL_PREFIX,
  getState: getAuthModal,
  modalOptions,
  logger,
};

/** @type {ReactReduxModal} */
export const reactReduxModal = new ReactReduxModal(options);

/** @type {ReactReduxModalActions} */
export const actions = reactReduxModal.actions;

const modalConfig = {
  actions: reactReduxModal.actions,
  getState: getAuthModal,
  logger,
};

options.modalComponent = ReactReduxModalHOC(AuthModal, modalConfig);

/**
 * showModal props:
 * @property {AuthModalMode} [allowedModes=LOGIN_AND_SIGNUP]
 * @property {AuthModalMode} [initialMode=LOGIN]
 * @property {Boolean} [showCloseButton=true]
 */



// WEBPACK FOOTER //
// ./src/js/auth/redux/authModal.js